import { takeLatest, call, put } from "redux-saga/effects";
import {
  SUBMIT_COMPETITOR_LIST_REQUEST,
  submitCompetitorListSuccess,
  submitCompetitorListFailure,
} from "../actions/competitorListActions";
import { fetchCompetitorList } from "../../../services/accIqService";

// Worker Saga
function* handleCompetitorListSubmission(action) {
  try {
    const { client, user_id, user_type, user_role } = action.payload;
    const response = yield call(
      fetchCompetitorList,
      client,
      user_id,
      user_type,
      user_role
    );
    yield put(submitCompetitorListSuccess(response));
  } catch (error) {
    yield put(
      submitCompetitorListFailure(error?.message || "Something went wrong")
    );
  }
}

// Watcher Saga
export function* watchCompetitorListSubmission() {
  yield takeLatest(
    SUBMIT_COMPETITOR_LIST_REQUEST,
    handleCompetitorListSubmission
  );
}
